export type ClientType = 'individual' | 'company';

export type Client = {
  id: string;
  companyId: string;
  type: ClientType;
  name: string;
  businessName: string;
  taxId: string;
  email: string;
  phone: string;
  address: string;
  notes: string;
  active: boolean;
  createdAt: Date;
  updatedAt: Date;
};

export type ClientInput = {
  type: ClientType;
  name: string;
  businessName: string;
  taxId: string;
  email: string;
  phone: string;
  address: string;
  notes: string;
  active: boolean;
};

export const CLIENT_TYPE_LABELS: Record<ClientType, string> = {
  individual: 'Persona',
  company: 'Empresa',
};
